import { render, staticRenderFns } from "./ChallengeActivityOverview.vue?vue&type=template&id=2d2525d0&scoped=true&lang=pug&"
import script from "./ChallengeActivityOverview.vue?vue&type=script&lang=js&"
export * from "./ChallengeActivityOverview.vue?vue&type=script&lang=js&"
import style0 from "./ChallengeActivityOverview.vue?vue&type=style&index=0&id=2d2525d0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2525d0",
  null
  
)

export default component.exports